import styled, { css } from "styled-components";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import MoreVertIcon from "@material-ui/icons/MoreVert";

import PaletteIcon from "@material-ui/icons/Palette";
import FormatSizeIcon from "@material-ui/icons/FormatSize";
import TextFormatIcon from "@material-ui/icons/TextFormat";
import CheckIcon from "@material-ui/icons/Check";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import OpenWithIcon from "@material-ui/icons/OpenWith";
import RestorePageIcon from "@material-ui/icons/RestorePage";

export const AutoResizingTextArea = styled.textarea`
  width: 100%;
  min-width: 170px;
  min-height: 50px;
  color: ${(props) => props.textColor};
  background-color: ${(props) => props.noteColor};
  font-size: ${(props) => props.textSize + "px"};
  line-height: ${(props) => props.textSize * 1.1 + "px"};
  overflow: hidden;
  resize: none;
  padding: 4px;
  box-sizing: border-box;
  cursor: ${(props) => (props.readOnly ? "pointer" : "auto")};
  pointer-events: ${(props) => (props.readOnly ? "none" : "auto")};
  caret-color: ${(props) => (props.readOnly ? "transparent" : "auto")};
  border-radius: 5px;
`;

export const Lock = styled(LockIcon)`
  position: absolute;
  top: -2px;
  right: -28px;
  color: black;
  z-index: 500;
  font-size: 16px;
  cursor: pointer;
`;
export const Unlock = styled(LockOpenIcon)`
  position: absolute;
  top: -2px;
  right: -28px;
  color: black;
  z-index: 500;
  font-size: 16px;
  cursor: pointer;
`;
export const Container = styled.div`
  display: flex;
  color: ${(props) => props.textColor};
  background-color: ${(props) => props.noteColor};
  min-height: 50px;
  min-width: 200px;
  width: ${(props) => props.width + "px" || "auto"};
  resize: ${(props) => (props.resizable ? "horizontal" : "none")};
  box-sizing: border-box;
  cursor: ${(props) => (props.isLocked ? "pointer" : "auto")};
  overflow: hidden;
  border-radius: 5px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  &:hover {
    box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.3);
  }
`;

export const MenuToggle = styled(MoreVertIcon)`
  position: absolute;
  top: 25px;
  right: -28px;
  z-index: 500;
  font-size: 16px;
  background-color: ${(props) =>
    props.isOpen ? "#000" : "#fff"}; // Invert background color
  color: ${(props) => (props.isOpen ? "#fff" : "#000")}; // Invert icon color
  cursor: ${(props) => (props.isLocked ? "pointer" : "auto")};
  border-radius: 100%;
`;

export const CustomNoteMenu = styled.div`
  height: 33px;
  border-radius: 5px;
  position: absolute;
  top: -35px;
  background-color: #111;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: ${(props) => (props.isExtended ? "275px" : "200px")}; // 200px normal
  transition: width 0.3s ease, height 0.3s ease;
`;

const baseIconStyle = css`
  font-size: 16px;
  background-color: #eee;
  color: #000;
  cursor: pointer;
  border: none; // No border
  border-radius: 5px; // Rounded corners

  &:hover {
    background-color: #aaa; // Change on hover
  }

  &:focus {
    outline: none; // Removes outline on focus
  }
`;

export const TextColor = styled(TextFormatIcon)`
  ${baseIconStyle}
`;

export const FillColor = styled(PaletteIcon)`
  ${baseIconStyle}
`;

export const TextSize = styled(FormatSizeIcon)`
  ${baseIconStyle}
`;

export const ConfirmButton = styled(CheckIcon)`
  ${baseIconStyle}
  color: #0a0;
`;
export const DeleteButton = styled(DeleteForeverIcon)`
  ${baseIconStyle}
  color: #a00;
`;
export const MoveButton = styled(OpenWithIcon)`
  ${baseIconStyle}
`;
export const RestoreButton = styled(RestorePageIcon)`
  ${baseIconStyle}
`;

export const SizeInputContainer = styled.div`
  display: flex;
  align-items: center;
  border: none;
  border-radius: 5px;
  overflow: hidden; // Hide content that overflows the container
  width: ${(props) =>
    props.show ? "75px" : "0"}; // Start with 0 width if not shown
  transition: width 0.3s ease; // Animate width changes

  button {
    ${baseIconStyle}
    margin: 0;
    width: 20px;
    height: 20px;
    opacity: ${(props) => (props.show ? "1" : "0")}; // Fade the button in/out
    transition: opacity 0.3s ease 0.3s; // Delay button opacity transition until width transition is done
  }

  input {
    ${baseIconStyle}
    width: 30px;
    height: 20px;
    text-align: center;
    border: none;
    outline: none;
    opacity: ${(props) => (props.show ? "1" : "0")}; // Fade the input in/out
    transition: opacity 0.3s ease 0.3s; // Delay input opacity transition until width transition is done

    -webkit-appearance: none;
    -moz-appearance: textfield;
    appearance: none;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &::-ms-clear {
      display: none;
    }
  }
`;
